module.exports = __webpack_public_path__ + "img/homeCountBg.ed5eb238.png";